/* OVO product pages - shared behaviour (AIOS 2026-08-25). Safe to include many times. */
(function () {
  if (window.__ovopJs) return;
  window.__ovopJs = true;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.ovop-reveal:not(.is-in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  function initVideos() {
    document.querySelectorAll('[data-ovop-video]:not([data-ovop-ready])').forEach(function (btn) {
      btn.setAttribute('data-ovop-ready', '1');
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-ovop-video');
        var f = document.createElement('iframe');
        f.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', btn.getAttribute('data-ovop-title') || 'Video');
        btn.replaceWith(f);
      });
    });
  }

  function initAr() {
    document.querySelectorAll('[data-ovop-ar]:not([data-ovop-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ovop-ready', '1');
      var btn = wrap.querySelector('.ovop-ar__btn');
      var modal = wrap.querySelector('.ovop-ar__modal');
      var close = wrap.querySelector('.ovop-ar__close');
      var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (!btn || !modal) return;
      if (!isMobile) {
        btn.addEventListener('click', function (e) { e.preventDefault(); modal.classList.add('is-open'); });
        if (close) close.addEventListener('click', function () { modal.classList.remove('is-open'); });
        modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('is-open'); });
      }
    });
  }

  function boot() { initReveal(); initVideos(); initAr(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
